import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    fetchLatestVersion({ commit }) {
        return axios
            .get('/app-management/whats-new/latest')
            .then(response => {
                commit('SET_LATEST_VERSION_DATA', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie informacji o nowej wersji nie powiodło się.')

                return Promise.reject(error)
            })
    }
}
